import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import FormInput from '../../components/FormInput/FormInput';
import Checkbox from '../../components/Checkbox/Checkbox';
import Button from '../../components/Button/Button';
import api from '../../services/api';

function UpdatePassword() {
  usePageTitle('Reset password');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword]               = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword]       = useState(false);
  const [errors, setErrors]                   = useState({});
  const [loading, setLoading]                 = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!password)                        errs.password        = 'Password is required';
    else if (password.length < 8)         errs.password        = 'Password must be at least 8 characters';
    if (password !== confirmPassword)     errs.confirmPassword = 'Passwords do not match';
    if (!token)                           errs.general         = 'Invalid or missing reset token.';
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setErrors({});
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      navigate('/login');
    } catch (err) {
      setErrors({ general: err.response?.data?.error || 'Something went wrong. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Update password">
      <form onSubmit={handleSubmit}>
        {errors.general && <p style={{ color: 'var(--red-500)', fontSize: '0.85rem', marginBottom: 12 }}>{errors.general}</p>}

        <FormInput
          id="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          placeholder=""
          value={password}
          onChange={e => { setPassword(e.target.value); setErrors(v => ({ ...v, password: '' })); }}
          error={errors.password}
        />

        <FormInput
          id="confirmPassword"
          label="Confirm password"
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          placeholder=""
          value={confirmPassword}
          onChange={e => { setConfirmPassword(e.target.value); setErrors(v => ({ ...v, confirmPassword: '' })); }}
          error={errors.confirmPassword}
        />

        {/* Reveals both fields at once, same control as the login screen. */}
        <div className="mb-4">
          <Checkbox
            id="showPassword"
            label="Show password"
            checked={showPassword}
            onChange={() => setShowPassword(prev => !prev)}
          />
        </div>

        <Button type="submit" disabled={loading}>
          {loading ? 'Saving…' : 'Save changes'}
        </Button>
      </form>
    </AuthLayout>
  );
}

export default UpdatePassword;
